import { PrismicRichText } from '@prismicio/react';
import { ReactElement, useEffect, useState } from 'react';

import { linkResolver } from '@prismic/prismic-config';

import downloadIconPath from 'images/download_file_icon.svg';
import downloadIconActivePath from 'images/download_file_icon_active.svg';
import placeholderImgPath from 'images/download_file_placeholder.svg';

import { SliceFields, SliceFileLink, IFiles, IProps } from './types';
import * as S from './styles';

function compareStrings(str1: string | null, str2: string | null): boolean {
  if (str1 === null || str2 === null) {
    return false;
  }

  return (
    str1.toLowerCase().replace(' ', '') === str2.toLowerCase().replace(' ', '')
  );
}

export function SliceDownloadFiles({
  slice: { fields },
}: IProps): ReactElement {
  const initialFilesState: IFiles = {};
  const [files, setFiles] = useState(initialFilesState);
  const [currentCategory, setCurrentCategory] = useState('');

  useEffect(() => {
    const categoriesList = [
      ...new Set(
        fields.map((item) => item.filecategory).filter((item) => item !== null)
      ),
    ];
    const structuredFiles: IFiles = {};
    categoriesList.forEach((cat) => {
      if (!cat) {
        return;
      }

      structuredFiles[cat] = fields.filter((item) =>
        compareStrings(item.filecategory, cat)
      ) as SliceFields[];
    });

    setFiles(structuredFiles);

    if (categoriesList.length > 0) {
      setCurrentCategory(categoriesList[0] as string);
    }
  }, []);

  const setActiveCategory = (category: string) => {
    setCurrentCategory(category);
  };

  return (
    <S.Wrapper className="slice-item slice-download-files">
      {currentCategory && (
        <>
          {/* Tab */}
          {Object.keys(files) && (
            <S.TabList className="slice-download-files__categories-list">
              {Object.keys(files).map((category) => (
                <S.TabElement
                  className={
                    compareStrings(currentCategory, category)
                      ? 'slice-download-files__category active'
                      : 'slice-download-files__category'
                  }
                  key={`slice-download-files__category_${category}`}
                >
                  <button
                    onClick={() => setActiveCategory(category)}
                    type="button"
                  >
                    {category}
                  </button>
                </S.TabElement>
              ))}
            </S.TabList>
          )}
          {/* TabPanel  */}
          {files[currentCategory] && (
            <S.TabPanel className="slice-download-files__tab-panel">
              {files[currentCategory].map((item, i) => {
                const _link = item.filelink as SliceFileLink;
                if (!_link) {
                  return null;
                }

                return (
                  <S.TabItem
                    className="slice-download-files__tab-item"
                    key={`${i}`}
                  >
                    <a
                      href={linkResolver(_link)}
                      download="FileName"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="tab-item__prev-img"
                        src={
                          item.filelogo ? item.filelogo.url : placeholderImgPath
                        }
                        alt={
                          item.filelogo ? item.filelogo.alt : 'download file'
                        }
                      />
                      <div className="tab-item__text-wr">
                        <div>
                          {item.filetitle && (
                            <div className="tab-item__title">
                              <PrismicRichText field={item.filetitle} />
                            </div>
                          )}
                          {item.filedescription && (
                            <div className="tab-item__description">
                              <PrismicRichText field={item.filedescription} />
                              {_link?.size && (
                                <div className="tab-item__size">
                                  {Math.floor((_link?.size || 0) / 1024)} kb
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <div className="tab-item__icon-wr">
                          <img
                            className="tab-item__icon-img tab-item__icon-img--active"
                            src={downloadIconActivePath}
                            alt=""
                          />
                          <img
                            className="tab-item__icon-img"
                            src={downloadIconPath}
                            alt=""
                          />
                        </div>
                      </div>
                    </a>
                  </S.TabItem>
                );
              })}
            </S.TabPanel>
          )}
        </>
      )}
    </S.Wrapper>
  );
}

SliceDownloadFiles.componentName = 'download-files';
